.field {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-2);
}

.label {
	display: inline-flex;
	gap: var(--spacing-1);
	align-items: center;
	font-size: var(--font-size-sm);
	font-weight: var(--font-weight-medium);
	color: var(--colour-text-primary);
}

.required {
	color: var(--colour-danger);
}

.hint {
	display: inline-flex;
	color: var(--colour-text-secondary);
	cursor: help;
	border-radius: var(--radius-full);

	& > svg {
		inline-size: 0.875rem;
		block-size: 0.875rem;
	}
}

.description {
	margin: 0;
	font-size: var(--font-size-sm);
	color: var(--colour-text-secondary);
}

.error {
	margin: 0;
	font-size: var(--font-size-sm);
	color: var(--colour-danger);
}

.inline {
	display: flex;
	gap: var(--spacing-3);
	align-items: center;

	& .label {
		cursor: pointer;
	}
}
